import axios from 'axios';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { FaFilePdf } from 'react-icons/fa6';
import { toast } from 'react-toastify';
import { IExpense } from '../../../../../types';

import { IconWrapper } from '../../../../IconWrapper/IconWrapper';
import styles from './Infos.module.scss';

interface IInfosProps {
  expense: IExpense;
}

const Infos = ({ expense }: IInfosProps) => {
  const [totalDistance, setTotalDistance] = useState<string>('0');
  const [totalRepaid, setTotalRepaid] = useState<string>('0');

  useEffect(() => {
    const sum = expense.lines.reduce((acc, obj) => acc + obj.distance, 0);
    let repaid = 0;

    if (sum < 5000) {
      repaid = sum * 0.665;
    } else if (sum < 20000) {
      repaid = sum * 0.374 + 1457;
    } else {
      repaid = sum * 0.447;
    }

    setTotalDistance(sum.toFixed(0));
    setTotalRepaid(repaid.toFixed(2).replace('.', ','));
  }, [expense]);

  const getDocument = (document: string) => () => {
    axios
      .get(`/api/expense/${expense._id}/document/${document}`, {
        responseType: 'blob',
      })
      .then((response) => {
        //Create a Blob from the PDF Stream
        const file = new Blob([response.data], { type: 'application/pdf' });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        const pdfWindow = window.open();
        if (pdfWindow !== null) pdfWindow.location.href = fileURL;
      })
      .catch((err) => toast.error(err.response.data.message));
  };

  return (
    <Card className={styles.Card}>
      <Card.Header>Infos</Card.Header>
      <Card.Body>
        <Row className="mb-2">
          <Col>
            <Form.Label htmlFor="total_distance">Total distance</Form.Label>
            <Form.Control
              name="total_distance"
              value={`${totalDistance} km`}
              type="text"
              readOnly
            />
          </Col>
        </Row>
        <Row className="mb-2">
          <Col>
            <Form.Label htmlFor="total_repaid">Total to be repaid</Form.Label>
            <Form.Control name="total_repaid" value={`${totalRepaid} €`} type="text" readOnly />
          </Col>
        </Row>
        <Row>
          <Col className="d-flex align-items-center mt-3">
            <Button variant="secondary" onClick={getDocument('report')} className="w-100">
              <Row className="d-flex align-items-center">
                <Col sm={1}>
                    <IconWrapper icon={FaFilePdf} />
                </Col>
                <Col>Expense report</Col>
              </Row>
            </Button>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default Infos;
